import React, { useRef, useEffect } from "react";

// Create context with socket included
const AppRecordsContext = React.createContext({
  socket: null,
  croppingToolProps: {
    url: "",
    setOpenCroppingToolPanel: () => {},
    setCroppedImage: () => {},
    uploadFile: () => {},
    setCustomFileUploaderProps: () => {}
  },
  matchPredictorContext: {
    teamListData: undefined,
    setTeamListData: () => {} 
  },
  registerUploadCallback: () => {},
  sendNotification: () => {}
});

export function AppRecordsProvider({ children, socket }) {
  const callbackRegistry = useRef(new Map());

  useEffect(() => {
    if (!socket) return;
    function onFileUploadComplete(data) {
      const cb = callbackRegistry.current.get(data.fileName);
      if (cb) {
        cb(data);
        callbackRegistry.current.delete(data.fileName);
      }
    }
    socket.on("fileUploadComplete", onFileUploadComplete);
    return () => socket.off("fileUploadComplete", onFileUploadComplete);
  }, [socket]);

  const registerUploadCallback = (fileName, cb) => {
    callbackRegistry.current.set(fileName, cb);
  };

  const sendNotification = (title, message, type = "Info") => {
    if (socket) {
      socket.emit('createNotification', { title, message, type });
    }
  };

  // Add socket to context value
  const contextValue = {
    socket,
    croppingToolProps: { /* ... */ },
    matchPredictorContext: { /* ... */ },
    registerUploadCallback,
    sendNotification
  };

  return (
    <AppRecordsContext.Provider value={contextValue}>
      {children}
    </AppRecordsContext.Provider>
  );
}

export default AppRecordsContext;